import { useCallback, useEffect, useState } from "react";
import { IAnalyticsSummary } from "../../../types/types";
import { fetchAnalyticsSummary } from "../services/analyticsServices";

export const TRAFFIC_PERIODS = [
  { label: "24 h", hours: 24 },
  { label: "7 pv", hours: 24 * 7 },
  { label: "30 pv", hours: 24 * 30 },
] as const;

export const useTrafficSummary = () => {
  const [sinceHours, setSinceHours] = useState<number>(24);
  const [summary, setSummary] = useState<IAnalyticsSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadSummary = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchAnalyticsSummary(sinceHours);
      setSummary(data);
    } catch {
      setError("Liikennetietojen lataus epäonnistui.");
    } finally {
      setLoading(false);
    }
  }, [sinceHours]);

  useEffect(() => {
    void loadSummary();
  }, [loadSummary]);

  return {
    sinceHours,
    setSinceHours,
    summary,
    loading,
    error,
    periods: TRAFFIC_PERIODS,
  };
};
